
export const header = [
    {  chat:'Chat with us', phone:'+420 336 775 664',
    email:'webbrainacademy@gmail.com',
    blog:'Blog',
    about:'About us',
    career:'Careers',
    searchCategory:'All category',
    order:'Order',
    summary:'Summary',
     }
]